module.exports = __webpack_public_path__ + "img/sort-filter.d1de9fbc.svg";